import { render } from "./ProductionBio.vue?vue&type=template&id=c3b2c3c2"
import script from "./ProductionBio.vue?vue&type=script&lang=js"
export * from "./ProductionBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__